export const LIVE_TAG = {
  SUPER_STAR_KOL: ['明星主播'],
}
